import { palette } from './palette';

export const homeStyle = {
  '.drawer-wrapper': {
    '& .drawer-title-container, .drawer-close-button': {
      color: palette.text.highlight,
    },
  },
  '.popup-action-button': {
    color: palette.primary.contrastText
  },

  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,

      '& .logo-image': {
        height: 46,
      },

      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',
  
        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },
  
        '& .hero-shaped__image': {
          width: '60vw',
          
          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          }
        },
      },
    }
  },

  '.ponce-container': {
    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      '@media(min-width: 900px)': {
        backgroundImage: 'linear-gradient(90deg, #FFFFFF 36%, #FFF4E8 0%)',
      },

      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,

        '& .hero-title': {
          maxWidth: 500,
          lineHeight: '55px',

          '@media(min-width: 900px)': {
            lineHeight: '80px',
          },
        },
        '& .hero-subtitle': {
          maxWidth: 500
        },
      },
      '& .image-wrapper': {
        '@media(max-width: 900px)': {
          backgroundImage: 'linear-gradient(90deg, #FFFFFF 16%, #FFF4E8 0%)',
          padding: '24px 48px 24px 16px',
        },
        '& .image': {
          boxShadow: 'none',
          height: 'auto',
        },
      },
    },

    /* Benefits - Styles */
    '& #definition-section': {
      '@media(max-width: 900px)': {
        paddingTop: 0,
      },
      '& .benefits-wrapper': {
        borderTop: `4px solid ${palette.text.primary}`,
        paddingTop: 48,

        '@media(min-width: 900px)': {
          paddingTop: 72,
        },
      },

      '& .section-header': {
        '@media(min-width: 900px)': {
          paddingBottom: 50,
        },
        '& .section-header__title': {
          color: '#456134',
        }
      },

      '& .definition-service-tile': {
        padding: (32, 32, 16),

        '& .definition-service-innertile': {
          '& .definition-service-title': {
            color: palette.primary.main,
          },
          '& .definition-service-description': {
            paddingBottom: 48,
            borderBottom: `1px solid ${palette.text.primary}`,
          }
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      backgroundColor: palette.background.main,

      '& .subscription-bg': {
        position: 'unset',
        height: 576,
        background: `url('./images/home-images/pricing-benefits.webp') no-repeat center`,
        backgroundSize: 'cover',

        '@media(max-width: 900px)': {
          background: `url('./images/home-images/pricing-benefits-mobile.webp') no-repeat center`,
        },
      },
      '& #pricing-benefit-section': {
        '& .subscription-section': {
          '& .section-header': {
            maxWidth: 600,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
        },

        '& .planCard': {
          color: palette.text.primary,

          '& .MuiButton-root': {
            borderWidth: 2,
            color: palette.text.primary,
          },
        },

        '& .planCard:hover': {
          '& .MuiButton-root': {
            backgroundColor: palette.primary.main,
            color: palette.primary.contrastText,
          },
        },

        '& .summary-text': {
          marginTop: '0 !important',
          paddingTop: '0 !important',
        },
        '& .carousel-container': {
          paddingBottom: 0
        },

        '& .savings-summary-link': {
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: 'unset',

      '& .section': {
        borderBottom: `2px solid ${palette.text.disabled}`,
      },
      '& .howitworks-wrapper': {
        '& .how-cover-image': {
          height: 'auto',
        }
      },
      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
        marginBottom: 0,
        borderBottom: `1px solid ${palette.text.disabled}`,
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      paddingBottom: 80,
      '& .section-alternate': {
        borderBottom: `1px solid ${palette.text.disabled}`,
      },

      '& .section-header__overline-wrapper': {
        color: palette.primary.main,
      },

      '& .testimonial-title-wrapper': {
        '& .section-header__title': {
          maxWidth: 500,
        }
      },
      '& .testimonial-container': {
        flexDirection: 'column-reverse',

        '@media(min-width: 900px)': {
          flexDirection: 'row-reverse',
        },
      },
      '& .testimonial-content-wrapper': {
        marginTop: 10,
        '@media(min-width: 900px)': {
          marginTop: -200,
        },
        
        '& .react-multi-carousel-track': {
          paddingTop: 60,
          '@media(min-width: 900px)': {
            paddingTop: 200,
          },
        },
        '& .custom-arrow': {
          border: 0,
          backgroundColor: 'unset',
          top: 0,
          width: 40,
          height: 40,
        },
        '& .left-arrow': {
          right: 75,
          left: 'unset',
        }, 
        '& .testimonial-message': {
          color: palette.text.primary,
          fontFamily: 'OpenSauceSans',
          fontWeight: 400,
        },
      },
      '& .image-wrapper': {
        display: 'flex',
        justifyContent: 'center',

        '@media(min-width: 900px)': {
          justifyContent: 'left',
        },

        '& .image': {
          height: '100%',
          width: 'auto',

          '@media(min-width: 900px)': {
            height: 414,
          },
        }
      }
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      paddingBottom: 80,
      
      '& .hero-static-bg': {
        backgroundColor: 'unset',
      },
      '& .hero-static-section': {
        backgroundColor: palette.primary.main,
        borderRadius: 32,

        '@media(max-width: 900px)': {
          margin: (0, 20),
        },

        '& .section-header__title': {
          color: palette.text.highlight,
          maxWidth: 600,
        }
      }
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .service-plan-table .savings-subheader': {
        backgroundColor: palette.background.main,
        fontWeight: 600,
      },
    },

    /* Static Page Hero Banners */
    '& .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .savings-hero-section, & .faq-hero-section, & .faq-contact-wrapper': {
      backgroundColor: palette.background.main,
    },
    '& .book-appointment-hero-section': {
      height: '100%',
      backgroundColor: palette.background.main,
      
      '& .MuiTypography-root': {
        color: palette.text.primary,
      }
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .find-provider-section, & .plan-selection-section, & .checkout-hero-section': {
        background: palette.background.main,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .planCard': {
        '&:hover': {
          color: palette.text.primary,
        }
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .home-static-hero-wrapper': {
        '& .hero-static-bg': {
          backgroundColor: palette.background.main,
        },
      },
      '& .plans-wrapper': {
        '& .highlight-button': {
          backgroundColor: palette.text.highlight,
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled,
        },
      },
    },

    /* Footer Disclosure */
    '& .footer-wrapper, & .footer-wrapper a': {
      backgroundColor: palette.primary.main,
      color: palette.text.highlight,
    },
 
    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      }
    },
  },
};